import * as React from 'react';
import { connect } from 'react-redux';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, domain } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { isNullOrUndefined } from 'util';
import SwitchButton from '../shared/switchButtonV4.jsx';


class FirmaDigitale extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfirm: false
        }
        this.componentName = '[FirmaDigitale.jsx] ';
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.inputChangeHandlerFirmaDigitale = this.inputChangeHandlerFirmaDigitale.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

    }

    inputChangeHandler(e) {
        console.log(this.componentName + " inputChangeHandler");
        if (e !== null && e !== undefined) {

            let value = e.target.value;
            let id = e.target.id;
            let type = e.target.type;
            if (value === "[object Object]") {
                value = "";
            }

            if (type === "number" && value === "") {
                value = null;
            }

            if (type === "checkbox") {
                value = e.target.checked;
            }

            if (!isNullOrUndefined(type) && type === "radio") {
                id = e.target.name;
            }
            if (this.props.validation.has(id)) {
                this.props.validation.delete(id);
            }
            this.props.handleChange(id, value)
        }
    }

    inputChangeHandlerFirmaDigitale(e) {
        console.log(this.componentName + " inputChangeHandlerFirmaDigitale");
        if (e !== null && e !== undefined) {

            let value = e.target.value;
            let id = e.target.id;
            let type = e.target.type;
            if (value === "[object Object]") {
                value = "";
            }

            if (type === "number" && value === "") {
                value = null;
            }

            if (type === "checkbox") {
                value = e.target.checked;
            }

            if (!isNullOrUndefined(type) && type === "radio") {
                id = e.target.name;
            }
            if (this.props.validation.has(id)) {
                this.props.validation.delete(id);
            }
            this.props.handleChangeFirmaDigitale(id, value)
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div>
                <div className="row mt-4 rowServizioEsterno">

                    <SwitchButton
                        id="flMailFirmaDigitale"
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.FIRMA_DIGITALE', 'Servizio Mail Firma Digitale')}
                        value={this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true}
                        componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                        onChange={this.inputChangeHandler}
                    />
                </div>
                <div className="row ">

                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true ?
                        <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                            <agui.ASelectV4
                                id="nomeServizio"
                                onChange={this.inputChangeHandlerFirmaDigitale}
                                value={this.props.prodottoFirmaDigitale?.nomeServizio ? this.props.prodottoFirmaDigitale?.nomeServizio : null}
                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO.SERVIZI_DISPONIBILI', 'Servizi Disponibili')}
                                items={domain('FIRMA_DIGITALE')}
                                componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                                validation={this.props.validation}
                                disabled={this.props.disabled}
                                valueKey="valCampo"
                                labelKey="desDom"
                            />
                        </div>
                        : null}

                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true && this.props.prodottoFirmaDigitale?.nomeServizio !== "NAMIRIAL" && this.props.prodottoFirmaDigitale?.nomeServizio !== "" ?
                        <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                            <agui.ASelectV4
                                id="tipoAutenticazione"
                                onChange={this.inputChangeHandlerFirmaDigitale}
                                value={this.props.prodottoFirmaDigitale?.tipoAutenticazione ? this.props.prodottoFirmaDigitale?.tipoAutenticazione : null}
                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO.TIPO_AUTENTICAZIONE', 'Tipo Autenticazione')}
                                items={domain('TIPO_AUTENTICAZIONE')}
                                componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                                validation={this.props.validation}
                                disabled={this.props.disabled}
                                valueKey="valCampo"
                                labelKey="desDom"
                            />
                        </div>
                        : null}

                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true && this.props.prodottoFirmaDigitale.nomeServizio && this.props.prodottoFirmaDigitale.nomeServizio === "NAMIRIAL" &&
                        <agui.ATextInputV4 id="user" type="text"
                            value={this.props.prodottoFirmaDigitale ? this.props.prodottoFirmaDigitale?.user : null}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO_FIRMA_DIGITALE.USER', 'User')}
                            onChange={this.inputChangeHandlerFirmaDigitale}
                            componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                            validation={this.props.validation}
                            disabled={this.props.disabled}
                            required
                        />
                    }
                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true && (!isNullOrUndefined(this.props.prodottoFirmaDigitale?.nomeServizio) && this.props.prodottoFirmaDigitale.nomeServizio !== "")   ?
                        <agui.ATextInputV4 id="url" type="text"
                            value={this.props.prodottoFirmaDigitale ? this.props.prodottoFirmaDigitale?.url : null}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO_FIRMA_DIGITALE.URL', 'URL')}
                            onChange={this.inputChangeHandlerFirmaDigitale}
                            componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                            validation={this.props.validation}
                            disabled={this.props.disabled}
                            required
                        />
                        : null}

                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true  && this.props.prodottoFirmaDigitale.nomeServizio && this.props.prodottoFirmaDigitale.nomeServizio === "NAMIRIAL" &&
                        <agui.ATextInputV4 id="orgId" type="password"
                            value={this.props.prodottoFirmaDigitale ? this.props.prodottoFirmaDigitale?.orgId : null}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO_FIRMA_DIGITALE.ORGID', 'ORGID')}
                            onChange={this.inputChangeHandlerFirmaDigitale}
                            componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                            validation={this.props.validation}
                            disabled={this.props.disabled}
                            required
                        />
                    }

                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true && this.props.prodottoFirmaDigitale.nomeServizio && (this.props.prodottoFirmaDigitale.nomeServizio === "MMC" || this.props.prodottoFirmaDigitale.nomeServizio === "DOCUSIGN") &&
                        <agui.ATextInputV4 id="apiKey" type="password"
                            value={this.props.prodottoFirmaDigitale ? this.props.prodottoFirmaDigitale?.apiKey : null}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO_FIRMA_DIGITALE.API_KEY', 'API KEY')}
                            onChange={this.inputChangeHandlerFirmaDigitale}
                            componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                            validation={this.props.validation}
                            disabled={this.props.disabled}
                            required
                        />
                    }

                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true && this.props.prodottoFirmaDigitale.nomeServizio && this.props.prodottoFirmaDigitale.nomeServizio === "DOCUSIGN" &&
                        <agui.ATextInputV4 id="clientId" type="text"
                            value={this.props.prodottoFirmaDigitale ? this.props.prodottoFirmaDigitale?.clientId : null}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO_FIRMA_DIGITALE.CLIENT', 'Client Id')}
                            onChange={this.inputChangeHandlerFirmaDigitale}
                            componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                            validation={this.props.validation}
                            disabled={this.props.disabled}
                            required
                        />
                    }

                    {this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true && this.props.prodottoFirmaDigitale.nomeServizio && this.props.prodottoFirmaDigitale.nomeServizio === "DOCUSIGN" &&
                        <agui.ATextInputV4 id="rsaKey" type="text"
                            value={this.props.prodottoFirmaDigitale ? this.props.prodottoFirmaDigitale?.rsaKey : null}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO_FIRMA_DIGITALE.RSA_KEY', 'Rsa Key')}
                            onChange={this.inputChangeHandlerFirmaDigitale}
                            componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                            validation={this.props.validation}
                            disabled={this.props.disabled}
                            required
                        />
                    }

                </div>
            </div>

        )
    }
    ;
}
function mapStateToProps(state) {
    return {
        prodotto: state.prodotto.detailsProdotto,
        prodottoFirmaDigitale: state.prodotto.prodottoFirmaDigitale
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleChange(index, e) {
            return dispatch(ProdottoActions.handleChange(index, e))
        },
        handleChangeFirmaDigitale(index, e) {
            return dispatch(ProdottoActions.handleChangeFirmaDigitale(index, e))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FirmaDigitale);